<template>
  <div class="background" :style="customStyle">
    <img v-if="type !== 'none'" alt="background" :src="imgUrl" :class="classByType" />
    <div class="background-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Background',
  props: {
    type: String,
    customStyle: String
  },
  computed: {
    classByType() {
      const { type } = this;
      return type === 'tollfree' || type === 'local' || type === 'porting'
        ? 'background-img-numbers'
        : type === 'mobile'
        ? 'background-img-mobile'
        : 'background-img';
    },
    imgUrl() {
      let name = '';
      switch (this.type) {
        case 'auth':
          name = 'background';
          break;
        case 'number-selection':
          name = 'background2';
          break;
        case 'tollfree':
          name = 'numbers_bg_tollfree';
          break;
        case 'local':
          name = 'numbers_bg_local';
          break;
        case 'porting':
          name = 'numbers_bg_porting';
          break;
        case 'mobile':
          name = 'mobile_bg';
          break;
        default:
          break;
      }
      const images = require.context('@/assets/images', false, /\.png$/);
      return images('./' + name + '.png');
    }
  }
};
</script>

<style scoped lang="scss">
.background {
  width: 100vw;
  height: 100vh;
  background-color: $colorBack;
  position: relative;
  overflow: auto;

  .background-img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
  }

  .background-img-mobile {
    position: absolute;
    right: 0;
    height: 100%;
  }

  .background-img-numbers {
    max-width: 100vw;
    position: absolute;
    top: 85px;
    height: calc(100% - 85px);
    right: 0px;
  }

  .background-content {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 1280px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .background-content {
      height: unset;
    }

    .background-img-numbers {
      top: 70vh;
      right: unset;
      height: unset;
      width: 100%;
      object-fit: contain;
      transform: matrix(0, -1, 1, 0, 0, 0);
      position: fixed;
    }
  }
}
</style>
